// import { useSelector, useDispatch } from "react-redux";
// import { closeUpgradeModal } from "../../data/redux/slices/UpgradePlanModalSlice";
// import { useNavigate } from "react-router-dom";

// const UpgradePlanModal = () => {
//   const { upgradePlanOpen, errorMessage } = useSelector((state) => state.upgradePlan);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   if (!upgradePlanOpen) return null;

//   const goToUpgradePage = () => {
//     dispatch(closeUpgradeModal());
//     navigate("/general-settings/upgrade-plan");
//   };

//   return (
//     <div className="modal fade show d-block" role="dialog">
//       <div className="modal-dialog modal-dialog-centered">
//         <div className="modal-content">
//           <div className="modal-body text-center">
//             <h4>Upgrade Plan</h4>
//             <p>{errorMessage || "Your current plan does not support this action."}</p>
//             <button
//               className="btn btn-danger me-2"
//               onClick={() => dispatch(closeUpgradeModal())}
//             >
//               Close
//             </button>
//             <button className="btn btn-primary" onClick={goToUpgradePage}>
//               Upgrade Now
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UpgradePlanModal;

import { useSelector, useDispatch } from "react-redux";
import { closeUpgradeModal } from "../../data/redux/slices/UpgradePlanModalSlice";
import { useNavigate } from "react-router-dom";

const UpgradePlanModal = () => {
  const { upgradePlanOpen, errorMessage } = useSelector((state) => state.upgradePlan);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  if (!upgradePlanOpen) return null;

  const goToUpgradePage = () => {
    dispatch(closeUpgradeModal());
    navigate("/general-settings/upgrade-plan");
  };

  // Inline styles
  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1050,
    animation: "fadeIn 0.3s ease-in-out",
  };

  const modalStyle = {
    backgroundColor: "#fff",
    borderRadius: "1rem",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
    maxWidth: "400px",
    width: "90%",
    textAlign: "center",
    padding: "2rem 1.5rem",
  };

  const titleStyle = {
    color: "#4f46e5",
    fontWeight: 700,
    marginBottom: "1rem",
    fontSize: "1.5rem",
  };

  const messageStyle = {
    color: "#555",
    marginBottom: "2rem",
  };

  const buttonStyle = {
    padding: "0.6rem 1.5rem",
    borderRadius: "0.5rem",
    fontWeight: 600,
    cursor: "pointer",
    border: "none",
  };

  const cancelBtnStyle = {
    ...buttonStyle,
    backgroundColor: "#e5e7eb",
    color: "#111",
    marginRight: "0.5rem",
  };

  const upgradeBtnStyle = {
    ...buttonStyle,
    background: "linear-gradient(90deg, #4f46e5, #6366f1)",
    color: "#fff",
    transition: "transform 0.2s, box-shadow 0.2s",
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h4 style={titleStyle}>Upgrade Your Plan 🚀</h4>
        <p style={messageStyle}>
          {errorMessage || "Your current plan does not support this action. Upgrade to unlock!"}
        </p>
        <div>
          <button
            style={cancelBtnStyle}
            onClick={() => dispatch(closeUpgradeModal())}
          >
            Cancel
          </button>
          <button
            style={upgradeBtnStyle}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 6px 12px rgba(99,102,241,0.5)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "none";
            }}
            onClick={goToUpgradePage}
          >
            Upgrade Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradePlanModal;
